import type {
  BlocksLotteryRuleDescription,
  BlocksRuleItem,
  BlocksTransactionFeeTier,
} from "../ui/components/blocks/types";

export function buildDefaultTransactionFeeTiers(): BlocksTransactionFeeTier[] {
  return [
    {
      label: "بدون اولویت",
      priority: "no-priority",
      minutes: 24 * 60,
      satsPerVByte: 12,
      usdPerTransaction: null,
    },
    {
      label: "اولویت کم",
      priority: "low",
      minutes: 3 * 60,
      satsPerVByte: 18,
      usdPerTransaction: null,
    },
    {
      label: "اولویت متوسط",
      priority: "medium",
      minutes: 60,
      satsPerVByte: 28,
      usdPerTransaction: null,
    },
    {
      label: "اولویت بالا",
      priority: "high",
      minutes: 10,
      satsPerVByte: 42,
      usdPerTransaction: null,
    },
  ];
}

export const DEFAULT_LOTTERY_RULE: BlocksLotteryRuleDescription = {
  headline: "قرعه‌کشی با تکیه بر بلاک آینده",
  details:
    "خرید برای بلاک بعدی انجام می‌شود و وقتی همان بلاک استخراج شد، نویسه آخر هدر بلاک تعیین می‌کند آیا جایزه به شرکت‌کننده برمی‌گردد یا خیر.",
  steps: [
    {
      title: "ثبت‌نام برای بلاک بعدی",
      description:
        "کاربر پس از ورود با تلگرام، فرم مشارکت بلاک بعدی را تکمیل می‌کند و شماره بلیت اختصاص می‌گیرد.",
    },
    {
      title: "استخراج بلاک",
      description:
        "به محض انتشار بلاک بعدی، هدر آن در جدول وارد می‌شود و همه می‌توانند صحت آن را روی اکسپلورر بررسی کنند.",
    },
    {
      title: "اعلام برنده",
      description:
        "اگر آخرین نویسه یکی از حروف e یا f باشد، قرعه‌کشی بین بلیت‌ها اجرا می‌شود و نتیجه در داشبورد و ربات تلگرام نمایش داده می‌شود.",
    },
  ],
};

export const DEFAULT_BLOCK_RULES: BlocksRuleItem[] = [
  {
    id: "desc",
    text: "خرید توسط شرکت‌کننده اول هر بلاک انجام می‌شود و سایر شرکت‌کنندگان در قرعه‌کشی ثبت‌نام می‌شوند. در صورتی که شرایط برد وجود وجود داشته باشد (نویسه آخر هدر بلاک استخراج شده e یا f باشد)، از روی هفت نویسه پیش از آخرین نویسه شماره بلیط برنده مشخص می‌شود. برای امکان خرید صندوق باید موجودی کافی داشته باشد.",
  },
  {
    id: "legal",
    text: "پیش از استفاده از سایت و ربات مطمئن شوید این سرویس در کشور محل اقامت شما منع قانونی ندارد.",
  },
  {
    id: "age",
    text: "استفاده از این سرویس فقط برای افراد بالای ۱۸ سال مجاز است.",
  },
  {
    id: "uptime",
    text: "هیچ تضمینی بابت ادامهٔ فعالیت یا عملکرد دقیق سرویس ارائه نمی‌شود و ممکن است هر لحظه متوقف شود، بازنشانی گردد یا تغییر کند.",
  },
];
